<template>
    <div>
        <a-card title="旧版存档" size="small" style="" :bordered="false">
            <p>有空间限制(最大5MB)，但是使用比较流畅，也能被所有设备所支持</p>
            <a-skeleton :loading="loading" active>
                <storage-table :data="storage"
                    @download="downloadStorage" @clear="clearStorage"
                ></storage-table>
            </a-skeleton>
        </a-card>
        <a-card title="新版存档" size="small" style="" :bordered="false">
            <p>没有空间限制，但是不够稳定（部分手机设备可能会随机丢失），同时部分设备可能也不支持</p>
            <a-skeleton :loading="loading" active>
                <storage-table :data="forage"
                    @download="downloadForage" @clear="clearForage"
                ></storage-table>
            </a-skeleton>
        </a-card>
        <p>从V2.4开始，存档会分为旧版localStorage存档和新版localForage存档。<br/>
            在<a-tag>游戏菜单-系统设置-新版存档</a-tag>中可以对存档方式进行切换，请根据需要酌情选择。
        </p>
    </div>
</template>

<script>
import localforage from 'localforage'
import StorageTable from '../components/StorageTable.vue'
import axios from '../../../../plugins/axios'
import { formatSize } from '../../../../utils/utils'

export default {
    data: () => ({
        storage: [],
        forage: [],
        towerList: {},
        loading: false,
    }),
    async created() {
        this.loading = true;
        const { data } = await axios.get("/games/info.php", {
            params: {
                type: 'list'
            }
        });
        this.towers = {};
        this.storageMap = {};
        this.forageMap = {};
        for (let tower of data) {
            this.towers[tower.name] = tower.title;
        }
        Object.keys(localStorage).forEach((key) => {
            this.buildMap(this.storageMap, key, localStorage.getItem(key).length);
        });
        await localforage.iterate((value, key) => {
            if (value.length > 0) this.buildMap(this.forageMap, key, value.length);
        });
        for (let i in this.storageMap) {
            this.storage.push({
                name: i,
                title: this.towers[i],
                num: this.storageMap[i].saves.length,
                size: this.storageMap[i].size
            })
        }
        this.loading = false;
    },
    methods: {
        clearStorage(name) {
            if (!name) {
                localStorage.clear();
                this.storage = [];
            } else {
                this.storageMap[name].saves.forEach(({ name }) => {
                    localStorage.removeItem(name);
                })
                delete this.storageMap[name];
                this.storage = this.storage.filter(e => e.name != name);
            }
        },     
        async clearForage() {
            if (!name) {
                await localforage.clear();
                this.localforage = [];
            } else {
                this.forageMap[name].saves.forEach(({ name }) => {
                    localforage.removeItem(name);
                })
                delete this.forageMap[name];
                this.forage = this.forage.filter(e => e.name != name);
            }
        },
        downloadStorage() {

        },
        async downloadForage() {

        },
        formatSize,
        buildMap(map, key, size) {
            const e = /^(\w+)_(save\d+|autoSave)$/.exec(key);
            if (e == null) return;
            const name = e[1];
            if (map[name] == undefined) {
                map[name] = { "num": 0, "size": 0, "saves": [] };
            }
            map[name].size += size;
            map[name].saves.push({"name": key, "size": size});
        }
    },
    components: {
        StorageTable
    },
}
</script>

<style scoped>
.ant-card {
    background: none;
}
.ant-card >>> .ant-card-head-title {
    font-size: 18px;
    font-weight: bold;
}
</style>